function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "arrow-down_inline_svg__3_-sign-up",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow-down_inline_svg__2_-Login_web_s2_\\u6703\\u54E1\\u57FA\\u672C\\u8CC7\\u6599_\\u4E0B\\u62C9\\u9078\\u55AE",
  transform: "translate(-560 -367)",
  fill: "#999"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow-down_inline_svg__Atom-/-input-/-default",
  transform: "translate(480 331)"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow-down_inline_svg__Atom-/-icon-/-functional-/-down",
  transform: "translate(80 36)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.889 5.737l-.626-.626a.38.38 0 00-.538 0L8 10.82 2.275 5.11a.38.38 0 00-.538 0l-.626.626a.38.38 0 000 .537l6.62 6.615a.38.38 0 00.538 0l6.62-6.615a.38.38 0 000-.537z",
  id: "arrow-down_inline_svg__Path"
})))));

function SvgArrowDowninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgArrowDowninline;